'use strict';

var _ = require('lodash');
var FaresOptimizerPagerController = function FaresOptimizerPagerController($scope, $filter, recommendationTransformationService, pagerService) {
  $scope.initializePager = function () {
    $scope.numberOfMarketsToDisplay = [{
      label: '5',
      value: 5
    }, {
      label: '10',
      value: 10
    }, {
      label: '15',
      value: 15
    }, {
      label: '20',
      value: 20
    }];
    $scope.numberOfMarketsPerPageModel = $scope.numberOfMarketsToDisplay[0];
    $scope.numberOfMarketsPerPage = $scope.numberOfMarketsToDisplay[0].value;
  };
  $scope.updatePager = function () {
    if ($scope.screenState.isRawDataPresent) {
      $scope.screenState.marketRawDataChunks = _.chunk($scope.screenState.rawDataByMarket, $scope.numberOfMarketsPerPage);
      $scope.screenState.pager = pagerService.getPager($scope.numberOfMarketsPerPage, $scope.screenState.marketRawDataChunks.length);
      $scope.transformSelectedRawDataChunk(1);
    }
  };
  $scope.onChangeNumberOfMarketsToDisplay = function () {
    $scope.numberOfMarketsPerPage = $scope.numberOfMarketsPerPageModel.value;
    $scope.updatePager();
  };
  $scope.goToSelectedPage = function () {
    $scope.transformSelectedRawDataChunk($scope.screenState.pager.selectedPageToGo);
  };
  $scope.transformSelectedRawDataChunk = function (pageNumber) {
    var selectedPage = parseInt(pageNumber);
    if (selectedPage > 0 && selectedPage <= $scope.screenState.pager.totalPages) {
      pagerService.updatePagerUponPageChange($scope.screenState.pager, pageNumber, selectedPage);
      $scope.screenState.displayedRawData = _.flatten($scope.screenState.marketRawDataChunks[selectedPage - 1]);
      $scope.screenState.displayedRecommendationList = recommendationTransformationService.transformRawData($scope.screenState.displayedRawData, $scope.screenState.orderOptions);
    }
  };
  $scope.transformRawDataWithinSelectedPage = function () {
    if (!_.isNil($scope.screenState.pager) && !_.isNil($scope.screenState.pager.currentPage)) {
      $scope.screenState.displayedRecommendationList = recommendationTransformationService.transformRawData($scope.screenState.displayedRawData, $scope.screenState.orderOptions);
    }
  };
  $scope.initializePager();
  $scope.$watchCollection('screenState.rawDataByMarket', $scope.updatePager);
  $scope.$watchCollection('screenState.displayedRawData', $scope.transformRawDataWithinSelectedPage);
};
FaresOptimizerPagerController.$inject = ['$scope', '$filter', 'RecommendationTransformationService', 'FaresOptimizerPagerService'];
module.exports = FaresOptimizerPagerController;